import React, {useState, useEffect} from 'react';
import clsx from 'clsx';

// Wrap any content.  When not 'active', instead it will
// show a link to enable it.  Used for the agents-only
// Tax Exemption widget.

export default function ActivateLink(
  {
    children, onActivate = null, className = "activate-link",
    defaultOpen=false, ...props
  }) {

  const [active, setActive] = useState(!!defaultOpen);

  useEffect(() => {
      if (!active) return;

      if (onActivate)
        onActivate(props);
    }, [active]
  );

  const handleClick = (e) => {
    setActive(true);
  }

  if (!active) {
    const {prompt = "Click to activate"} = props;

    return (<a className={clsx(className)}
      onClick={handleClick}>{prompt}</a>);
  }

  const {tagName = 'div'} = props;

  const TagName = tagName; // avoid warnings
  return <TagName>{children}</TagName>
}
